var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BasicButton',_vm._g(_vm._b({attrs:{"appearance":"remove"}},'BasicButton',_vm.$attrs,false),_vm.$listeners),[_c('SvgIcon',{attrs:{"icon":"cross","size":"10"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }